/**
 * KAN-887: сортировка таблицы CRM. Адрес ?sort=<значение>; значение по
 * умолчанию для текущего периода в адрес не пишется: при периоде "По дате
 * взятия" (taken), при "Всё время" "По активности" (activity). Явно выбранная
 * сортировка переживает смену периода. Неизвестное значение - по умолчанию.
 */
import type { CrmTableSort } from '@/types/crm';
import type { CrmRange } from './crmTable';

export const CRM_SORT_PARAM = 'sort';

export const CRM_SORT_OPTIONS: readonly { value: CrmTableSort; label: string }[] = [
  { value: 'activity', label: 'По активности' },
  { value: 'taken', label: 'По дате взятия' },
  { value: 'temperature', label: 'По теплоте' },
  { value: 'next_contact', label: 'По следующей связи' },
  { value: 'stage', label: 'По этапу' },
  { value: 'manager', label: 'По менеджеру' },
];

/** Сортировка по умолчанию: при периоде по дате взятия, при "Всё время" по активности. */
export function defaultCrmTableSort(range: CrmRange | null): CrmTableSort {
  return range ? 'taken' : 'activity';
}

/** Сортировка из адреса; пустая или неизвестная - по умолчанию для периода. */
export function parseCrmTableSort(value: string | null, range: CrmRange | null): CrmTableSort {
  const known = CRM_SORT_OPTIONS.find((o) => o.value === value);
  return known ? known.value : defaultCrmTableSort(range);
}

/** Адрес с сортировкой: значение по умолчанию для периода убирает ?sort=. */
export function withCrmTableSort(prev: URLSearchParams, sort: CrmTableSort, range: CrmRange | null): URLSearchParams {
  const next = new URLSearchParams(prev);
  if (sort === defaultCrmTableSort(range)) next.delete(CRM_SORT_PARAM);
  else next.set(CRM_SORT_PARAM, sort);
  return next;
}

/** Заголовки дней взятия: только при периоде и сортировке по дате взятия. */
export function groupsByTakenDay(range: CrmRange | null, sort: CrmTableSort): boolean {
  return !!range && sort === 'taken';
}
